import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";

@Component({
    selector: "",
    template: `
        <ion-list>
            <ion-item (click)="selectSlide(i)" *ngFor="let group of groups; let i = index">
                <small>{{ group }}</small>
            </ion-item>
        </ion-list>
    `
})
export class FormSlidePickerComponent {

    groups: Array<any>;

    constructor(protected viewCtrl: ViewController, protected navParams: NavParams) {

    }

    ngOnInit(): void {
        this.groups = this.navParams.data.groups;
    }

    selectSlide(i): void {
        this.viewCtrl.dismiss(i);
    }

    close(): void {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/vas/pages/form/form-slide-picker.component.ts